module.exports = __webpack_public_path__ + "static/media/microbit-heart-trans.5cc95cb7.gif";